import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon } from "lucide-react";
import { company } from "../../data/company";
const facts = [{
  label: "Dirigeant",
  value: company.manager
}, {
  label: "Statut",
  value: `${company.status}, créé en ${company.created}`
}, {
  label: "Activité",
  value: company.naf
}, {
  label: "SIRET",
  value: company.siret
}, {
  label: "Adresse",
  value: `${company.address}, ${company.city}`
}];
export function AboutSection() {
  return <section aria-labelledby="about-title" className="px-3 lg:px-5" data-id="element-69" data-mp="3h195gfg0pgw0">
      <div className="mx-auto grid max-w-[1440px] gap-4 rounded-3xl bg-surface p-3 lg:grid-cols-[0.9fr_1.1fr] lg:gap-5 lg:p-5" data-id="element-70" data-mp="3h453e3rv85kg">
        <div className="relative min-h-[420px] overflow-hidden rounded-2xl" data-id="element-71" data-mp="37ciwukqh2uo1">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/cba0b5a6-3f4e-4f94-a905-c18e2aaaebcf.jpg" alt="Portrait de Ghenadii Copchilet, artisan peintre, dans une pièce fraîchement repeinte" className="absolute inset-0 h-full w-full object-cover" data-id="element-72" data-mp="8lz7njj5uxu1" />
        </div>

        <div className="flex flex-col justify-center px-4 py-10 lg:px-12 lg:py-14" data-id="element-73" data-mp="1qd38i5uifml3">
          <h2 id="about-title" className="text-4xl font-bold leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-74" data-mp="1bnyku94y4q5l">
            Un artisan, un interlocuteur, un travail suivi
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted" data-id="element-75" data-mp="12n0f9mev0akw">
            Je m'appelle Ghenadii Copchilet. J'ai créé mon entreprise à Meaux pour proposer un travail de peinture et de vitrerie fait avec soin : je réalise moi-même vos chantiers, de la préparation à la finition, et je reste votre seul contact.
          </p>

          <dl className="mt-10 divide-y divide-line border-y border-line" data-id="element-76" data-mp="xoyxr5x30jbj">
            {facts.map(f => <div key={f.label} className="grid gap-1 py-4 sm:grid-cols-[140px_1fr] sm:gap-6" data-id="element-77" data-mp="2n45ekr2hnlsk">
                <dt className="text-sm text-muted" data-id="element-78" data-mp="2s0vqd279fv86">{f.label}</dt>
                <dd className="text-sm font-semibold text-ink" data-id="element-79" data-mp="2qki2mlu2la9z">{f.value}</dd>
              </div>)}
          </dl>

          <Link to="/artisan" className="mt-10 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-ink px-6 py-3.5 text-[15px] font-semibold text-white transition-colors duration-150 hover:bg-ink-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-80" data-mp="2lkna6dunccmt">
            Découvrir l'artisan
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="34bmuv2v3z0aa" />
          </Link>
        </div>
      </div>
    </section>;
}